import React, { useEffect, useState } from "react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { getOneCourseById } from "../../store/apis/courses";
import { Player } from "video-react";
import VideoJS from "../../components/videoJs";
import { Row, Col, Button, Spin } from "antd";
import {
  CaretRightOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/loader";

function CourseView() {
  const [currentStep, setCurrentStep] = useState(null);
  const [selectedStepIndex, setSelectedStepIndex] = useState(0);
  const [openCourseStepIndex, setOpenCourseStepIndex] = useState(0);
  const [selectedCourseStepIndex, setSelectedCourseStepIndex] = useState("");
  const [stopNext, setStopNext] = useState(false);
  const [stopPrev, setStopPrev] = useState(false);

  const courseState = useSelector((state) => state?.courses?.course);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const courseId = window.location.pathname.split("/")[2];
    dispatch(getOneCourseById(courseId));
  }, []);

  const playerRef = React.useRef(null);

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    // this condition for localhost
    // crossorigin: "anonymous",
    playbackRates: [0.5, 1, 1.5, 2],
    sources: [
      {
        // src: courseState?.courseViseos[selectedCourseStepIndex]?.steps[
        //   selectedStepIndex
        // ]?.video,
        // src: "https://golancer.tech/public/videos/1678624887903larg-video.mp4",
      },
    ],
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    // You can handle player events here, for example:
    // player.on("waiting", () => {
    //   videojs.log("player is waiting");
    // });

    // player.on("dispose", () => {
    //   videojs.log("player will dispose");
    // });
  };

  useEffect(() => {
    const stepIndex = window.location.search.split("=")[1].split("-")[0];
    const courseStepIndex = window.location.search.split("=")[1].split("-")[1];
    if (stepIndex) {
      setSelectedStepIndex(stepIndex - 1);
      setSelectedCourseStepIndex(courseStepIndex - 1);
      setOpenCourseStepIndex(courseStepIndex - 1);
    }
  }, [window.location.search.split("=")[1]]);

  useEffect(() => {
    const stepsLength =
      courseState?.courseViseos[selectedCourseStepIndex]?.steps?.length - 1;
    const CurrentStepsLength = selectedStepIndex;

    const courseStepsLength = courseState?.courseViseos?.length - 1;
    const CurrentCourseStepsLength = selectedCourseStepIndex;
    if (
      courseStepsLength == CurrentCourseStepsLength &&
      stepsLength == CurrentStepsLength
    ) {
      setStopNext(true);
    } else {
      setStopNext(false);
    }
    console.log("selectedStepIndex", selectedStepIndex);
    console.log("selectedCourseStepIndex", selectedCourseStepIndex);
    if (selectedStepIndex === 0 && selectedCourseStepIndex === 0) {
      setStopPrev(true);
    } else {
      setStopPrev(false);
    }
  }, [selectedStepIndex, selectedCourseStepIndex, courseState?.courseViseos]);

  const handelCourseActions = (type) => {
    let fainalCoursesStepsLength = 1;
    let fainalStepsLength = 1;
    if (type === "prev") {
      const stepsLength =
        courseState?.courseViseos[selectedCourseStepIndex]?.steps?.length;
      const currentCoursesStepsLength = selectedCourseStepIndex + 1;
      const CurrentStepsLength = selectedStepIndex + 1;
      if (selectedStepIndex >= 1) {
        fainalStepsLength = CurrentStepsLength - 1;
        fainalCoursesStepsLength = currentCoursesStepsLength;
      } else {
        fainalStepsLength = stepsLength;
        fainalCoursesStepsLength = currentCoursesStepsLength - 1;
      }
      navigate(
        `/course-view/${courseState?._id}?step=${fainalStepsLength}-${fainalCoursesStepsLength}`
      );
    } else if (type === "next") {
      const stepsLength =
        courseState?.courseViseos[selectedCourseStepIndex]?.steps?.length;
      const currentCoursesStepsLength = selectedCourseStepIndex + 1;
      const CurrentStepsLength = selectedStepIndex + 1;

      if (stepsLength > CurrentStepsLength) {
        fainalStepsLength = CurrentStepsLength + 1;
        fainalCoursesStepsLength = currentCoursesStepsLength;
      } else {
        if (CurrentStepsLength === stepsLength) {
          fainalStepsLength = 1;
          fainalCoursesStepsLength = currentCoursesStepsLength + 1;
        } else {
          fainalStepsLength = CurrentStepsLength;
          fainalCoursesStepsLength = currentCoursesStepsLength + 1;
        }
      }
      navigate(
        `/course-view/${courseState?._id}?step=${fainalStepsLength}-${fainalCoursesStepsLength}`
      );
    }
  };

  const renderVideoSection = () => {
    // const videosData = [
    //   {
    //     itemIndex: 1,
    //     url: "https://drive.google.com/file/d/1oro8FN2Js_iXEYGCgl7-a0qyntuSGHYG/preview",
    //   },
    //   {
    //     itemIndex: 2,
    //     url: "https://drive.google.com/file/d/1oIITEvuEPYTpk_iW0hb9AgryFtWGr5rg/preview",
    //   },
    // ];
    return (
      <div className="course-video-container">
        <Row>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <div className="course-details">
              <h2> الخطة الدراسية للكورس </h2>
              {courseState?.courseViseos?.map((item, courseIndex) => {
                return (
                  <div className="step-title">
                    <h3
                      onClick={() => {
                        courseIndex === openCourseStepIndex
                          ? setOpenCourseStepIndex(-1)
                          : setOpenCourseStepIndex(courseIndex);
                        navigate(
                          `/course-view/${courseState?._id}?step=${1}-${
                            courseIndex + 1
                          }`
                        );
                      }}
                      style={{
                        fontWeight:
                          courseIndex === openCourseStepIndex ? "bold" : "",
                      }}
                    >
                      {courseIndex === openCourseStepIndex ? (
                        <UpOutlined />
                      ) : (
                        <DownOutlined />
                      )}
                      {item.stepTitle}
                    </h3>
                    <div
                      className={` ${
                        courseIndex === openCourseStepIndex &&
                        item?.steps?.length > 10 &&
                        "opened-step-title"
                      }`}
                    >
                      {item?.steps?.map((step, index) => {
                        if (courseIndex === openCourseStepIndex) {
                          return (
                            <div className="step-links">
                              <a
                                href={`/course-view/${courseState?._id}?step=${
                                  index + 1
                                }-${courseIndex + 1}`}
                                style={{
                                  fontWeight:
                                    selectedStepIndex === index &&
                                    selectedCourseStepIndex == courseIndex
                                      ? "bold"
                                      : "",
                                }}
                              >
                                <CaretRightOutlined
                                  className={
                                    selectedStepIndex === index
                                      ? "svg-color"
                                      : ""
                                  }
                                />
                                {step?.title}
                              </a>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col xs={24} sm={24} md={18} lg={18} xl={18}>
            <div className="course-video-box">
              <div className="course-video-title">
                <h2> {courseState?.title} </h2>
                <div className="next-prev-btns">
                  <div>
                    <Button
                      type="link"
                      onClick={() => handelCourseActions("next")}
                      disabled={stopNext}
                      style={{
                        color: stopNext ? "#ccc" : "",
                        fontWeight: stopNext ? "500" : "",
                      }}
                    >
                      التالي
                      <LeftOutlined />
                    </Button>
                  </div>
                  <div>
                    <Button
                      type="link"
                      onClick={() => handelCourseActions("prev")}
                      style={{
                        color: stopPrev ? "#ccc" : "",
                        fontWeight: stopPrev ? "500" : "",
                      }}
                      disabled={stopPrev}
                    >
                      <RightOutlined />
                      السابق
                    </Button>
                  </div>
                </div>
              </div>
              {/* {courseState?.courseViseos[selectedCourseStepIndex]?.steps[
                selectedStepIndex
              ]?.video && (
                <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
              )} */}
              {/* {videosData?.map((item) => {
                if (item.itemIndex === selectedStepIndex + 1) {
                  return (
                    );
                  }
                })} */}
              {courseState?.courseViseos && (
                <iframe
                  src={
                    courseState?.courseViseos[selectedCourseStepIndex]?.steps[
                      selectedStepIndex
                    ]?.video
                  }
                  width="100%"
                  height="750"
                ></iframe>
              )}
            </div>
            <div className="course-video-description">
              <h2> النص </h2>
              <p>
                {
                  courseState?.courseViseos[selectedCourseStepIndex]?.steps[
                    selectedStepIndex
                  ]?.videoDescription
                }
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="course-page-container">
      {courseState ? renderVideoSection() : <Loader />}
    </div>
  );
}

export default CourseView;
